<div mat-dialog-header class="title">
    Add Node
</div>

<div mat-dialog-content class="dialog-content">
    <div class="container">
        <mat-form-field>
        <mat-label>Device</mat-label>
        <mat-select (valueChange)="deviceUuid$.next($event.uuid)">
            <mat-option *ngFor="let device of devices$ | async" [value]="device">
                {{ device.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    </div>
</div>

<div mat-dialog-actions class="mat-mdc-dialog-actions action">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary"  (click)="handleAddNode()">Add</button>
</div>